import { PureComponent } from 'react';
import { Loading } from '@bumble/app/components/Loading';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

interface Data {
  epid?: string;
  total_bytes: number;
  rx_bytes: number;
  tx_bytes: number;
}
interface HorizontalBarChartProps {
  data: Data[];
  loading?: boolean;
}
export default class HorizontalBarChart extends PureComponent<HorizontalBarChartProps> {
  render() {
    const { data, loading } = this.props;
    const chartData = data.sort((a, b) => b.total_bytes - a.total_bytes);
    if (loading) return <Loading height={280} />;
    return (
      <ResponsiveContainer width="100%" height={(chartData.length + 1) * 60} minHeight={300}>
        <BarChart
          layout="vertical"
          width={500}
          height={300}
          data={chartData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis orientation="top" type="number" dataKey="total_bytes" />
          <YAxis orientation="left" type="category" dataKey="epid" width={160} />
          <Tooltip />
          <Legend verticalAlign="top" />
          <Bar dataKey="rx_bytes" fill="#62a9b6" barSize={20} name="RX Bytes" stackId="epid" />
          <Bar dataKey="tx_bytes" fill="#1E8497" barSize={20} name="TX Bytes" stackId="epid" />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}
